import { IconTrash } from '../../componentes/Icons';
import './ModalUsuarios.css';

const ModalUsuarios = ({ viewingUsers, setViewingUsers, handleDeleteUser }) => {
    return (
        <div className="master-modal-overlay">
            <div className="master-users-modal">
                <div className="modal-header">
                    <h3>Clientes: {viewingUsers.tenantName}</h3>
                    <button className="close-modal-btn" onClick={() => setViewingUsers(null)}>×</button>
                </div>
                <div className="modal-body">
                    <div className="users-table-container">
                        <table className="users-table">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Cargo</th>
                                    <th>E-mail</th>
                                    <th>WhatsApp</th>
                                    <th style={{ textAlign: 'center' }}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {viewingUsers.users?.map((u, i) => (
                                    <tr key={i}>
                                        <td>{u.name}</td>
                                        <td>
                                            <span className={`user-badge ${u.category}`}>
                                                {u.category === 'admin' ? 'Admin' :
                                                    u.category === 'barbeiro' ? 'Barbeiro' :
                                                        u.category === 'visitante' ? 'Visitante' : 'Cliente'}
                                            </span>
                                        </td>
                                        <td className="email-cell">{u.email}</td>
                                        <td>{u.whatsapp}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            {u.uid && u.category === 'cliente' ? (
                                                <button
                                                    className="action-btn delete"
                                                    title="Excluir Usuário"
                                                    onClick={() => handleDeleteUser(u)}
                                                    style={{ margin: '0 auto', background: 'rgba(255, 77, 77, 0.1)' }}
                                                >
                                                    <IconTrash />
                                                </button>
                                            ) : (
                                                <span style={{ opacity: 0.3, fontSize: '0.7rem' }}>Restrito</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalUsuarios;
